import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Avatar from '../../../Avatar'
import { getAssetLink } from '../../../helpers/get-asset-link'
import Checkbox from '../../FormLegacy/Checkbox'
import { getAgeStringTranslated } from '../helpers'

import { displayUserFullName } from './helpers'

export const HouseholdMember = ({ clientId, isChecked, isLoading, user, onChange, userBirth }) => {
  const { t } = useTranslation(['clients-legacy'])
  const onCheckboxChange = (e) => {
    onChange({ id: clientId, checked: e.target.checked })
  }

  return (
    <div className="visit-create-container">
      <div className="visit-create-user-container">
        <Avatar size="big">
          <img
            src={getAssetLink({ path: 'chitown-avatar/avatar', file: user.avatar })}
            alt={displayUserFullName(user)}
          />
        </Avatar>
        <span className="visit-create-user-name" title={displayUserFullName(user)}>
          {displayUserFullName(user)}
        </span>
        {getAgeStringTranslated(userBirth, t)}
      </div>
      <Checkbox
        checked={isChecked}
        className="checking-in-checkbox"
        disabled={isLoading}
        id={String(user.id)}
        onChange={onCheckboxChange}
      />
    </div>
  )
}

HouseholdMember.propTypes = {
  clientId: PropTypes.number,
  isChecked: PropTypes.bool,
  isLoading: PropTypes.bool,
  user: PropTypes.object,
  onChange: PropTypes.func,
  userBirth: PropTypes.string,
}
